import React, { useContext, useState } from 'react';
import store from '../../store';
import * as constants from '../../constants';
import { displayNameIsNull } from '../../constants/verifications';
// Custom Components
import { ModalConfirmButton, ModalCloseButton } from '../Buttons';
// Material components
import {
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
// Styles
import { flex } from '../../assets/jss';

export default function ChangeDisplayName() {
    // const classes = useStyles();
    const { state, reducers, profile, modals } = useContext(store);
    const { user } = state;
    const [name, setName] = useState('');

    const handleOpen = () => {
        reducers.handleModals('changeDisplayName', modals.changeDisplayName ? false : true)
    };

    const handleformData = (value) => {
        setName(value)
    }

    const handleSubmit = () => {
        if (name !== '') {
            var currentUser = constants.auth.currentUser;
            if (displayNameIsNull(user)) {
                console.log('display name is null')
                constants.updateProfile(currentUser, name)
                    .then(() => constants.createUserProfile_db(currentUser, handleOpen))
                    .catch((err) => console.log(err))
            } else if (!displayNameIsNull(user)) {
                console.log('display name not is null')
                constants.updateProfile(currentUser, name)
                    .then(() => constants.updateProfile_db(profile, currentUser))
                    .then(() => handleOpen())
                    .catch((err) => console.log(err))
            }
        }
    }

    return (
        <Dialog
            open={modals.changeDisplayName}
            onClose={displayNameIsNull(user) ? null : handleOpen}
            aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Change display name</DialogTitle>
            <DialogContent>
               Current display name: {profile.profile.displayName}
            </DialogContent>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Display Name"
                    type="text"
                    fullWidth
                    value={name}
                    onChange={(e) => handleformData(e.target.value)} />
            </DialogContent>
            <DialogActions style={flex.flex_row_around}>
            <ModalConfirmButton onClick={handleSubmit} />           
                {displayNameIsNull(user) ? null :
                     <ModalCloseButton onClick={handleOpen} />
                }
            </DialogActions>
        </Dialog>
    );
}